/**
 * HoverExpandDataGridPro
 *
 * A drop-in forwardRef component for `<DataGridPro>` providing stable, fixed-width
 * column rendering without automatic hover expansion/collapse animations.
 * All existing DataGridPro props, apiRef, and manual drag-to-resize features are forwarded unchanged.
 */
import { forwardRef } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';

const HoverExpandDataGridPro = forwardRef(function HoverExpandDataGridPro(
  props,
  ref
) {
  return (
    <DataGridPro
      {...props}
      ref={ref}
    />
  );
});

export default HoverExpandDataGridPro;
